import { useTranslationBundle } from '../hooks/UNSAFE_useTranslationBundle';
import { BundleType } from '../resources/nls/bundle';
import { useComponentTheme } from '../hooks/UNSAFE_useComponentTheme';
import { UserAssistanceVariantOptions } from './themes/UserAssistanceStyles.css';
import { UserAssistanceRedwoodTheme } from './themes/redwood/UserAssistanceTheme';

type Props = {
  align?: 'start' | 'end';
  hasMessages?: boolean;
  hasHelp?: boolean;
};

export function InlineRequired({ align = 'end', hasHelp = false, hasMessages = false }: Props) {
  const { classes } = useComponentTheme<UserAssistanceVariantOptions>(UserAssistanceRedwoodTheme, {
    align,
    visible: hasHelp || hasMessages ? 'hide' : 'show' // TODO: fix typing so that options autocomplete
  });

  const translations = useTranslationBundle<BundleType>('@oracle/oraclejet-preact');
  const requiredStr = translations.userAssistance_required();

  return <div class={classes}>{requiredStr}</div>;
}
